import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CpxHandleServiceAbstract, SessionTypeEnum } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { identifiantNationalKey, idnatStructureSettingKey, numeroAMFinessKey, typeStructureSettingKey } from 'src/app/services/dmp/dmp.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { environment } from 'src/environments/environment';

declare const DMPConnect: any;

interface NgSelectValue {
  id: string;
  libelle: string;
}

export interface ReturnRemplacement {
  identifiantNational: string;
  identifiantNationalStructure: string;
  typeStructure: string;
  numFacturation: string;
}

@Component({
  selector: 'app-enable-remplacement',
  templateUrl: './enable-remplacement.fragment.html',
  styleUrls: [
    './enable-remplacement.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class EnableRemplacement implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public modalTitle: string = 'Activation du mode remplacement';
  // Set directement lors de l'ouverture du modal

  @Output() public closeEmitter = new EventEmitter();

  formGroup: FormGroup;
  public healthcareFacilityTypeSettings: Array<NgSelectValue> = [];
  public dmpHealthcareFacilityTypeTableName = 'RefHealthcareFacilityTypeCodeDMP';

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeActivationRemplacement();
    }
  }

  constructor(
    private _viewContainerRef: ViewContainerRef,
    private _cpxHandleService: CpxHandleServiceAbstract,
    private _formBuilder: FormBuilder,
    private _refSrv: ReferentielService,
    private _loginService: LoginService,
    private _rsrSrv: RessourceService,
  ) { }

  async ngOnInit(): Promise<void> {
    const dmpHealthcareFacilityArrTmp = await this._refSrv.findRefListTableHypermed(this.dmpHealthcareFacilityTypeTableName);
    for (const ps of dmpHealthcareFacilityArrTmp) {
      this.healthcareFacilityTypeSettings.push({
        id: ps.id.split('++')[0],
        libelle: ps.libelle
      });
    }

    const params = await this.getAlreadySetParameters();
    this.formGroup = this._formBuilder.group({
      identifiantNational: [params.identifiantNational, Validators.required],
      numFacturation: [params.numFacturation, Validators.required],
      identifiantNationalStructure: [params.idnatStructureSetting, Validators.required],
      typeStructure: [params.typeStructureSetting, Validators.required],
    });
  }

  public closeActivationRemplacement(object?: ReturnRemplacement): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  public async lireCPS(): Promise<void> {
    const session = await this._cpxHandleService.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
    if (session.dmpConnectSessionInfos
      && session.dmpConnectSessionInfos.s_internalId
      && session.dmpConnectSessionInfos.i_internalIdType === DMPConnect.IdentifierType.IdentifierType_NationalIdentifierRpps
    ) {
      this.formGroup.get('identifiantNational').setValue(session.dmpConnectSessionInfos.s_internalId);
    } else {
      this.formGroup.get('identifiantNational').setValue(undefined);
    }

    if (session && session.practiceSettingIndice != null) {
      const practiceLocation = session.dmpConnectSessionInfos.PracticeLocations[session.practiceSettingIndice];
      this.formGroup.get('typeStructure').setValue(practiceLocation.s_practiceLocationActivity);
      this.formGroup.get('identifiantNationalStructure').setValue(practiceLocation.s_practiceLocationStructureId);
      // On supprime le premier chiffre du numéro de facturation
      const numFact = practiceLocation.s_practiceLocationBillingNumber.substring(1);
      this.formGroup.get('numFacturation').setValue(numFact);
    } else {
      this.formGroup.get('typeStructure').setValue(undefined);
      this.formGroup.get('identifiantNationalStructure').setValue(undefined);
      this.formGroup.get('numFacturation').setValue(undefined);
    }
  }

  validerForm(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.closeActivationRemplacement(this.formGroup.value);
    }
  }

  async getAlreadySetParameters(): Promise<any> {
    const profil = this._loginService.getCurrentProfil();
    const params = await this._rsrSrv.getResourceSettings(profil.id, 'profil');
    const alreadySetParameters:any = {};
    if (params) {
      const identifiantNationalSetting = params.find(p => p.settingKey === identifiantNationalKey);
      if (identifiantNationalSetting) {
        alreadySetParameters.identifiantNational = identifiantNationalSetting.settingValue;
      }
      const idnatStructureSetting = params.find(p => p.settingKey === idnatStructureSettingKey);
      if (idnatStructureSetting) {
        alreadySetParameters.idnatStructureSetting = idnatStructureSetting.settingValue;
      }
      const typeStructureSetting = params.find(p => p.settingKey === typeStructureSettingKey);
      if (typeStructureSetting) {
        alreadySetParameters.typeStructureSetting = typeStructureSetting.settingValue;
      }
      const numFacturationSetting = params.find(p => p.settingKey === numeroAMFinessKey);
      if (numFacturationSetting) {
        alreadySetParameters.numFacturation = numFacturationSetting.settingValue;
      }

    }

    return alreadySetParameters;
  }
}

